var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "maps-surface",
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.handleClearMap($event)
        }
      }
    },
    [
      _c("div", { staticClass: "map-container" }, [
        _c("div", { attrs: { id: "map-poligons" } }),
        _c("div", { staticClass: "calcs mg mg--t-2" }, [
          _c(
            "div",
            { staticClass: "head" },
            [
              _c("svgicon", {
                staticClass: "mg mg--r-2",
                attrs: {
                  name: "logoGen",
                  color: "#005BA5",
                  width: "48",
                  height: "20"
                }
              }),
              _c("p", { staticClass: "headline-medium mg mg--b-2" }, [
                _vm._v(_vm._s(_vm.$t("common.actualCalc")))
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mg mg--t-2 mg--b-3" },
            [
              _c("ma-input-radio", {
                attrs: {
                  type: "radio",
                  name: "toggleMapAction",
                  literal: "actions.select",
                  col: 4,
                  options: [
                    { key: "surface", literal: _vm.$t("common.surface") },
                    { key: "line", literal: _vm.$t("common.line") }
                  ]
                },
                on: {
                  change: function($event) {
                    _vm.dataType = $event
                  }
                }
              })
            ],
            1
          ),
          _vm.dataType === "surface"
            ? _c("p", { staticClass: "headline-small mg mg--b-1" }, [
                _vm._v(
                  _vm._s(_vm.$t("common.surface")) +
                    ": " +
                    _vm._s(_vm._f("floatToFixed")(_vm.area, 2)) +
                    " m²"
                )
              ])
            : _vm.dataType === "line"
            ? _c("p", { staticClass: "headline-small" }, [
                _vm._v(
                  _vm._s(_vm.$t("common.distance")) +
                    ": " +
                    _vm._s(_vm._f("floatToFixed")(_vm.distance, 2)) +
                    " m"
                )
              ])
            : _vm._e(),
          _c("p", { staticClass: "text-small mg mg--t-2" }, [
            _vm._v(_vm._s(_vm.$t("common.selectOnTheMap")))
          ])
        ])
      ]),
      _c("div", { staticClass: "bottom mg mg--t-2" }, [
        _c("div", { staticClass: "map-actions" }, [
          !_vm.viewer
            ? _c(
                "button",
                {
                  staticClass: "btn mainBlue mg mg--r-2",
                  on: { click: _vm.handleClickSelect }
                },
                [_vm._v(_vm._s(_vm.$t("actions.select")))]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "btn secondaryBlue",
              on: { click: _vm.handleClearMap }
            },
            [_vm._v(_vm._s(_vm.$t("actions.clear")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }